import { Mail, Phone } from "lucide-react";

import { APP, CONTACT_PHONE } from "@/lib/constants";
import { t } from "@/lib/content";
import type { Lang } from "@/lib/types";
import pageCopy from "@/data/page_copy.json";

type CcContactSidebarProps = {
  lang: Lang;
  /** Split layout aside: email + call only (no partner block). */
  mode?: "default" | "light" | "dark-aside";
};

function mailtoHref(
  address: string,
  hrefMap: Record<string, string> | string,
  lang: Lang,
): string {
  const query =
    typeof hrefMap === "string"
      ? hrefMap
      : hrefMap[lang] ?? hrefMap.en ?? "";
  return `mailto:${address}${query}`;
}

export function CcContactSidebar({ lang, mode = "default" }: CcContactSidebarProps) {
  const contact = pageCopy.contact;
  if (mode === "light" || mode === "dark-aside") {
    return (
      <aside
        className={`cc-contact__sidebar cc-contact__sidebar--light${
          mode === "dark-aside" ? " cc-contact__sidebar--dark-aside" : ""
        }`}
      >
        <div className="cc-contact__info-block">
          <h3 className="cc-contact__info-title">{t(contact.emailUs, lang)}</h3>
          <p className="cc-contact__info-lead">{t(contact.emailUsLead, lang)}</p>
          <a
            className="cc-contact__info-action"
            href={mailtoHref(APP.email.contact, APP.email.contactHref, lang)}
          >
            <Mail className="cc-contact__info-icon" aria-hidden />
            <span>{APP.email.contact}</span>
          </a>
        </div>
        <div className="cc-contact__info-block">
          <h3 className="cc-contact__info-title">{t(contact.callUs, lang)}</h3>
          <p className="cc-contact__info-lead">
            {t(contact.callUsLead, lang)}
            <span className="cc-contact__info-hours">{t(contact.callUsHours, lang)}</span>
          </p>
          <a
            className="cc-contact__info-action"
            href={`tel:${CONTACT_PHONE.tel}`}
          >
            <Phone className="cc-contact__info-icon" aria-hidden />
            <span>{CONTACT_PHONE.display}</span>
          </a>
        </div>
      </aside>
    );
  }

  return (
    <aside className="cc-contact__sidebar">
      <div className="cc-contact__info-block">
        <h3 className="cc-contact__info-title">{t(contact.contact, lang)}</h3>
        <a
          className="cc-contact__info-link"
          href={mailtoHref(APP.email.contact, APP.email.contactHref, lang)}
        >
          {APP.email.contact}
        </a>
      </div>
      <div className="cc-contact__info-block">
        <h3 className="cc-contact__info-title">{t(contact.partner, lang)}</h3>
        <a
          className="cc-contact__info-link"
          href={mailtoHref(APP.email.partner, APP.email.partnerHref, lang)}
        >
          {APP.email.partner}
        </a>
      </div>
    </aside>
  );
}
